/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetAssetPositionRestrictionsStatus200,
  GetAssetPositionRestrictionsStatus500,
} from '../types/GetAssetPositionRestrictions'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getAssetPositionRestrictions } from '../clients/getAssetPositionRestrictions'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getAssetPositionRestrictionsQueryKey = () =>
  [{ url: '/v1/assets/restrictions' }] as const

type GetAssetPositionRestrictionsQueryKey = ReturnType<typeof getAssetPositionRestrictionsQueryKey>

export function getAssetPositionRestrictionsQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getAssetPositionRestrictionsQueryKey()
  return queryOptions<
    GetAssetPositionRestrictionsStatus200,
    ResponseErrorConfig<GetAssetPositionRestrictionsStatus500>,
    GetAssetPositionRestrictionsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getAssetPositionRestrictions({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Returns every capped asset, for both the ordinary and the trading challenge audience.
 * @summary Get the open position size limits of every asset.
 * {@link /v1/assets/restrictions}
 */
export function useGetAssetPositionRestrictions<
  TData = GetAssetPositionRestrictionsStatus200,
  TQueryData = GetAssetPositionRestrictionsStatus200,
  TQueryKey extends QueryKey = GetAssetPositionRestrictionsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetAssetPositionRestrictionsStatus200,
        ResponseErrorConfig<GetAssetPositionRestrictionsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getAssetPositionRestrictionsQueryKey()

  const queryResult = useQuery(
    {
      ...getAssetPositionRestrictionsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetAssetPositionRestrictionsStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
